import {__loco} from "../../../utils/localization";
import {arrowDownIcon} from "../../../utils/svg-list";
import {getUserCurrency, siteSettings} from "../../../utils/siteSettings";
import {paymentMethods} from "../../../components/UIComponents/Payment/PaymentMethods";
import {getCheckoutDesktopSelectors} from "../selectors/checkoutSelectors";
import {animateScroll} from "../../../utils/animateScroll";
import {isOnScreen} from "../../../utils/isOnScreen";
import { SERVICE_CATEGORIES } from '../../../adlevo-vue/appConfiguration';

export class CheckoutSummary
{
    /**
     * Initialize
     * @param cartItems
     */
    init(cartItems)
    {
        const self = this;
        $(`.tour_availability__page__summary`).html(this.getTotalsTemplate(cartItems))
        $(`#mobileTicketSummary`).html(this.getTotalTemplateMobile(cartItems))

        $('#top-box-section-body > details').css('opacity', '0.1');

        if($(window).width() > 760) {

            const selectors = getCheckoutDesktopSelectors();

            /**
             * Click on book now.
             */
            $(document).on('click', '#floating-payment-btton', function (e){
                e.preventDefault();

                if($(selectors.payment.payer.name).val() === '') {
                    self.focusScroll(selectors.payment.payer.name);
                } else if ($(selectors.payment.payer.email).val() === '') {
                    self.focusScroll(selectors.payment.payer.email);
                } else if ($(selectors.payment.payer.phonenumber).val() === '') {
                    self.focusScroll(selectors.payment.payer.phonenumber);
                } else {
                    // all filled....
                    animateScroll('#payment-details-box', 300, 150);
                }
            });

            const $box = $('#payment-details-box');

            // @todo: Continue displaying book now button again.
            $(window).on('scroll', function(){
                // if(isOnScreen($box)) {
                //     console.log('box on screen');
                // } else  {
                //     console.log('box not on screen');
                // }
            });
        }
    }

    focusScroll(selector)
    {
        animateScroll(selector, 300, 215);
        $(selector).focus();
    }

    /**
     * Get summary template
     * @param cartItems
     * @return {string}
     */
    getTotalsTemplate(cartItems)
    {
        const self = this;

        return `
            <div class="booking-options-summary checkout-summary-container">
                  <h4 class="summary-title subtitle-2 checkout-summary-title">
                        ${__loco('Summary')}
                        <span class="mobile-toggle-summary">
                            ${arrowDownIcon()}
                        </span>
                    </h4>
                <div class="booking-options-summary-body">
                    ${self.renderCartItems(cartItems)}
                </div>
            </div>
        `;
    }

    getTotalTemplateMobile(cartItems){
        const self = this;

        return `<div class="booking-options-summary"> 
                   ${self.renderSelectedTicketsInMobileView(cartItems)}
        </div>`
    }

    /**
     * Render selected tickets.
     *
     * @return {string}
     */
    renderCartItems(cartItems)
    {
        let total = 0;
        let render = [];
        cartItems.forEach(cartItem => {
            switch (cartItem.getType()) {
                case SERVICE_CATEGORIES.ACTIVITIES:
                    total += parseFloat(cartItem.basket.total_price);
                    render.push(this.getActivityCartItemSummaryHtml(cartItem));
                    break;
                case SERVICE_CATEGORIES.HOTELS:
                    total += Number(cartItem.getTotal());
                    render.push(this.getHotelCartItemSummaryHtml(cartItem))
                    break;
            }
        });
        var totalHtml = "";
        // if (siteSettings().pspIsStripe){
            totalHtml = `
            <div class="options-summary-item options-summary-total light-theme">
                <div class="option-summary-item--name normal-text primary-text font-weight-bold">${__loco('Total')}</div>
                <div class="option-summary-item--cost normal-text primary-text font-weight-bold"> ${total.toFixed(2)} <span id="currency_type">${this.getCurrencyType(cartItems)}</span></div>
            </div>`;
        // }

        return `
            <div class="options-summary-items-container light-theme checkout-summary-items-list">

                ${render.join('')}
                ${totalHtml}

                <button
                    id="floating-payment-btton"
                    class="book-tickets-button btn btn-primary btn-block d-none"
                >
                       ${__loco('Book Now')}
                </button>
                
                ${paymentMethods('tour_availability__page__payment_methods')}
            </div>
        `;
    }

    getCurrencyType(cartItems) {
        let currencyType = null;
        cartItems.forEach(cartItem => {
            switch (cartItem.getType()) {
                case SERVICE_CATEGORIES.ACTIVITIES:
                    if(currencyType === null && cartItem.currency_type) {
                        currencyType = cartItem.currency_type
                    }
                    break;
                case SERVICE_CATEGORIES.HOTELS:
                    if(currencyType === null && cartItem.currency_type) {
                        currencyType = cartItem.currency_type
                    }
                    break;
            }
        });

        return currencyType ? currencyType : getUserCurrency() 
    }

    getActivityCartItemSummaryHtml (cartItem) {
        const tourTitle = cartItem.tour.name;
        const selectedTickets = cartItem.basket.selected_tickets;
        let tourTickets = [];
        Object.keys(selectedTickets).filter((tkey, ix) => {
            const ticket = selectedTickets[tkey];
            tourTickets.push(`
                    <div class="options-summary-item light-theme">
                        <div class="option-summary-item--name normal-text secondary-text">${ticket.tickets}x  ${ticket.ticket.display_name}</div>
                        <div class="option-summary-item--cost normal-text secondary-text">${Number(ticket.cost).toFixed(2)} ${cartItem.currency_type ? cartItem.currency_type : getUserCurrency()  }</div>
                    </div>
                `);
        });

        return`
                <div class="checkout-summary-items-container mb-3 border-bottom">
                    <h3 class="name_tour normal-text font-weight-medium ticketTourTitle">${tourTitle}</h3>
                    ${tourTickets.join('')}
                </div>
            `;
    }

    getHotelCartItemSummaryHtml(cartItem) {

        const hotelTitle = cartItem.getTitle();
        const roomTypes = cartItem.getRooms();
        const currency = getUserCurrency();
        const roomTypesElements = [];

        roomTypes.forEach(room => {

            roomTypesElements.push(`
                    <div class="options-summary-item light-theme">
                        <div class="option-summary-item--name normal-text secondary-text font-weight-bold">${room.title}</div>
                    </div>
            `)

            room.availability.forEach((roomAvailability) => {
                roomTypesElements.push(`
                    <div>
                    <div class="options-summary-item light-theme">
                        <div class="option-summary-item--name normal-text secondary-text">${roomAvailability.num_of_allotment}x ${__loco('Room')}</div>
                        <div class="option-summary-item--cost normal-text secondary-text">${room.price} ${room.currency_type ? room.currency_type : currency}</div>
                    </div>
                    </div>
                `);
            }, 0)
        })

        return`
                <div class="checkout-summary-items-container mb-3 border-bottom">
                    <h3 class="name_tour normal-text font-weight-medium ticketTourTitle">${hotelTitle}</h3>
                    ${roomTypesElements.join('')}
                </div>
            `;
    }

    renderSelectedTicketsInMobileView(cartItems)
    {
        let total = 0;

        let render = [];
        cartItems.forEach(cartItem => {
            switch (cartItem.getType()) {
                case SERVICE_CATEGORIES.ACTIVITIES:
                    total += parseFloat(cartItem.basket.total_price);
                    render.push(this.getActivityCartItemSummaryForMobileView(cartItem));
                    break;
                case SERVICE_CATEGORIES.HOTELS:
                    total += Number(cartItem.getTotal());
                    render.push(this.getHotelCartItemSummaryForMobileView(cartItem))
                    break;
            }
        });

        const totalHtml = `
                 <div class="row no-gutters justify-content-between light-theme mobileCheckoutSummaryItem">
                       <div class="col-auto">
                            <p class="normal-text">${__loco('Total')}</p>
                        </div>
                        <div class="col-auto">
                            <p class="subtitle-2 primary-text font-weight-medium">${total.toFixed(2)} ${this.getCurrencyType(cartItems)}</p>
                        </div>
                </div>
        `;

        return `
            <div class="options-summary-items-container mt-2 mb-0 pb-0 light-theme">
                ${render.join('')}
                ${totalHtml}
            </div>
        `
    }

    getActivityCartItemSummaryForMobileView(cartItem) {
        const tourTitle = cartItem.tour.name;
        const selectedTickets = cartItem.basket.selected_tickets;
        let tourTickets = [];
        Object.keys(selectedTickets).filter((tkey, ix) => {
            const ticket = selectedTickets[tkey];
            tourTickets.push(`
                    <div class="row no-gutters justify-content-between mobileCheckoutSummaryItem">
                        <div class="col-auto">
                            <div class="option-summary-item--name normal-text secondary-text">${ticket.tickets}x  ${ticket.ticket.display_name}</div>
                        </div>
                        <div class="col-auto">
                            <p class="option-summary-item--cost normal-text secondary-text">${Number(ticket.cost).toFixed(2)} ${cartItem.tour.currency_type ? cartItem.tour.currency_type : getUserCurrency() }</p>
                        </div>
                    </div>
                `);
        });

        return `
                <div class="checkout-summary-items-container mobileCheckoutSummaryItem">
                  <p class="subtitle-2 font-weight-bold">${tourTitle}</p>
                    ${tourTickets.join('')}
                </div>
            `
    }

    getHotelCartItemSummaryForMobileView(cartItem) {

        const hotelTitle = cartItem.getTitle();
        const roomTypes = cartItem.getRooms();
        const currency = getUserCurrency();
        const roomTypesElements = [];

        roomTypes.forEach(room => {
            room.availability.forEach((roomAvailability) => {
                roomTypesElements.push(`
                    <div>
                    <div class="options-summary-item light-theme">
                        <div class="option-summary-item--name normal-text secondary-text">${roomAvailability.num_of_allotment}x ${__loco('Room')}</div>
                        <div class="option-summary-item--cost normal-text secondary-text">${room.price} ${room.currency_type ? room.currency_type : currency}</div>
                    </div>
                    </div>
                `);
            }, 0)
        })

        return`
                <div class="checkout-summary-items-container mobileCheckoutSummaryItem">
                  <p class="subtitle-2 font-weight-bold">${hotelTitle}</p>
                    ${roomTypesElements.join('')}
                </div>
            `;

    }

}
